module.exports = __webpack_public_path__ + "static/img/4.7e1059d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/4.png
// module id = ivli
// module chunks = 0